import React from "react";

import TextInput from "../../../../components/formElements/input/TextInput";
import DateTimePicker from "../../../../components/formElements/datepicker/DateTimePicker";
import Card from "../../../../layout/Onboarding/Card";
import Row from "../../../../components/uiElements/grid/Row";
import Col from "../../../../components/uiElements/grid/Col";
import CardLable from "../../../../components/formElements/label/CardLabel";

export const SurgeryDetailsCard = ({
  personalPatientInfo,
  setPatientPersonalInfo,
  addPreviousSurgery,
  removePreviousSurgery,
  setPreviousSurgery,
  form,
}) => {
  return (
    <Card>
      <Row className="mt-4 mb-4">
        <Col>
          <CardLable
            name="Previous Surgery"
            condition={
              personalPatientInfo.current_surgery_name &&
              personalPatientInfo.current_surgery_date
            }
            onclick={() => addPreviousSurgery()}
            labelName={
              personalPatientInfo.current_surgery_name &&
              personalPatientInfo.current_surgery_date
                ? "Add"
                : ""
            }
          />
        </Col>
        <Col className="mt-3 mb-2">
          <TextInput
            id="current_surgery_name"
            // error={form.surgery_name}
            type="text"
            label="Surgery Details"
            value={personalPatientInfo.current_surgery_name}
            onChange={val =>
              setPatientPersonalInfo({ current_surgery_name: val })
            }
          />
          <div className="mb-3" style={{ marginTop: "-30px" }}>
            <DateTimePicker
              mode="date"
              // error={form.surgery_date}
              type="personalPatientInfo"
              placeholder="Date of Surgery"
              value={personalPatientInfo.current_surgery_date}
              customInput={true}
              onChange={val =>
                setPatientPersonalInfo({ current_surgery_date: val })
              }
            />
          </div>
        </Col>
        {personalPatientInfo.surgery_details !== null
          ? personalPatientInfo.surgery_details.map((value, index) =>
              value.surgery_name === "" ? (
                ""
              ) : (
                <Col className="mt-5 mb-2 ">
                  <Row>
                    <Col className="mb-3">
                      <CardLable
                        name={"Previous Surgery " + (index + 1)}
                        condition={null}
                        onclick={() => removePreviousSurgery(index)}
                        labelName="Remove"
                      />
                    </Col>
                    <Col>
                      <TextInput
                        id="surgery_name"
                        type="text"
                        label="Surgery Details"
                        value={value.surgery_name}
                        onChange={val =>
                          setPreviousSurgery("surgery_name", val, index)
                        }
                      />
                      <div className="mb-3" style={{ marginTop: "-30px" }}>
                        <DateTimePicker
                          mode="date"
                          type="personalPatientInfo"
                          placeholder="Date of Surgery"
                          value={value.surgery_date}
                          customInput={true}
                          onChange={val =>
                            setPreviousSurgery("surgery_date", val, index)
                          }
                        />
                      </div>
                    </Col>
                  </Row>
                </Col>
              )
            )
          : ""}
      </Row>
    </Card>
  );
};
